/**
 * Observes the .entry-content element's inner width (without padding-inline)
 * and sets the --sts-entry-content-width CSS custom property on :root.
 */
function updateEntryContentWidth(entry) {
    let width;

    if (entry.contentBoxSize && entry.contentBoxSize.length > 0) {
        width = entry.contentBoxSize[0].inlineSize;
    } else {
        // Fallback: offsetWidth minus computed padding-inline
        const el = entry.target;
        const style = getComputedStyle(el);
        const paddingInline =
            parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
        width = el.offsetWidth - paddingInline;
    }

    document.documentElement.style.setProperty(
        '--sts-entry-content-width',
        `${width}px`
    );
}

export function initEntryContentWidth() {
    const el = document.querySelector('.entry-content');
    if (!el) {
        return;
    }

    if (typeof ResizeObserver === 'undefined') {
        // Fallback for environments without ResizeObserver
        const style = getComputedStyle(el);
        const paddingInline =
            parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
        const width = el.offsetWidth - paddingInline;
        document.documentElement.style.setProperty(
            '--sts-entry-content-width',
            `${width}px`
        );
        return;
    }

    const observer = new ResizeObserver((entries) => {
        for (const entry of entries) {
            updateEntryContentWidth(entry);
        }
    });

    observer.observe(el, { box: 'content-box' });
}
